<template>
    <section id="dashboard" v-loading="loading">
        <el-container>
            <el-input placeholder="Search text" v-model="search" style="width:400px;"></el-input>
            <el-select v-model="formType" placeholder="Form Type" style="width:200px">
                <el-option label="All Forms" :value="null"></el-option>
                <el-option label="Furniture+Lighting" value="lighting"></el-option>
                <el-option label="Future House" value="house"></el-option>
            </el-select>
            <el-button type="primary" @click="loadData">Search</el-button>
            <el-button v-if="formType" type="primary" @click="downloadCSV">Download CSV</el-button>
        </el-container>
        <el-table
            :default-sort="{prop: 'id', order: 'descending'}"
            :data="tableData"
            stripe
            @sort-change="handleSortChange"
            style="width: 100%">
            <el-table-column prop="id" label="ID" width="70" sortable>
            </el-table-column>
            <el-table-column prop="form_type" label="Type" width="80" align="center" sortable></el-table-column>
            <el-table-column prop="created_at" label="Created At" sortable></el-table-column>
            <el-table-column prop="paid_at" label="Paid At" sortable></el-table-column>
            <el-table-column prop="pay_method" label="Payment Method" sortable></el-table-column>
            <el-table-column prop="payment_reference" label="Payment Ref." sortable></el-table-column>
            <el-table-column
                fixed="right"
                label=""
                width="120">
                <template slot-scope="{ row, column, $index }">
                    <el-button icon="el-icon-edit" @click="handleShowDetails(row)" size="small">View</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="pageSize"
            :page-sizes="[10, 20, 30, 40]"
            layout="sizes, prev, pager, next, total"
            :total="total">
        </el-pagination>
        <el-dialog
            :title="modalTitle"
            :visible.sync="dialogVisible"
            width="1000px">
            <template v-if="rowToShow">
                <template v-for="(section, idx) in rowToShow.content" style="margin-bottom:20px;">
                    <el-row class="detailrow" :gutter="10" :key="'title'+idx">
                        <el-col :span="idx==0?8:24">
                            {{ section.title }}
                        </el-col>
                        <el-col span="16" v-if="idx==0" align="right">
                            <el-popconfirm title="Are you sure?" @confirm="sendInvoice(true)"
                                           v-loading.fullscreen.lock="fullScreenLoading">
                                <el-button slot="reference" size="medium">Send Pre-Invoice</el-button>
                            </el-popconfirm>
                            <el-popconfirm title="Are you sure?" @confirm="sendInvoice()">
                                <el-button slot="reference" size="medium">Send Invoice</el-button>
                            </el-popconfirm>
                            <el-button size="medium" v-if="rowToShow.proforma" @click="getInvoice(rowToShow.id, 'proforma')">Download Pre-Invoice</el-button>
                            <span>
                                <el-button size="medium" v-if="rowToShow.invoice" @click="getInvoice(rowToShow.id, 'invoice')">Download Invoice</el-button>
                            </span>
                        </el-col>
                    </el-row>
                    <el-row class="detailformfield" :gutter="10" :key="'detailrow'+idx" v-if="section.type=='cols'">
                        <template v-for="(field, fieldId) in section.fields">
                            <el-col class="labelfield" :title="field.fieldname" span="6" :key="'fieldname'+idx+fieldId">
                                {{ field.fieldname }}
                            </el-col>
                            <el-col class="valuefield" span="6" :key="'fieldvalue'+idx+fieldId">
                                {{ field.value ? field.value : '-' }}
                            </el-col>
                        </template>
                    </el-row>
                    <div v-else :key="'detailtext'+idx">
                        {{ section.value }}
                    </div>
                </template>
            </template>
            <el-row class="detailrow" :gutter="10">
                <el-col span="24">
                    Files
                </el-col>
            </el-row>
            <el-row :gutter="10" v-if="rowToShow && rowToShow.files && rowToShow.files.length>0">
                <el-col span="6" v-for="(file, fileIdx) in rowToShow.files" :key="'file'+fileIdx">
                    <el-button @click="getFile(file)" icon="el-icon-download">Download File {{ fileIdx + 1 }}
                    </el-button>
                </el-col>
            </el-row>
            <el-row :gutter="10" v-else>
                <el-col span="24">
                    No files uploaded
                </el-col>
            </el-row>
        </el-dialog>
    </section>
</template>

<script>
import adminApi from '../api'

export default {
    name: 'Dashboard',
    data() {
        return {
            loading: false,
            search: null,
            formType: null,
            currentPage: 1,
            pageSize: 10,
            descriptionColumns: 2,
            sort: {prop: 'id', order: 'descending'},
            total: 0,
            tableData: [],
            dialogVisible: false,
            rowToShow: null,
            fullScreenLoading: false
        }
    },
    created() {
        this.loadData();
    },
    computed: {
        modalTitle() {
            if (this.rowToShow) {
                return '#GDN-' + this.rowToShow.form_type + '-' + this.rowToShow.id;
            }
            return '';
        }
    },
    methods: {
        getInvoice(form_id, type) {
            window.location.href = `/api/v1/form-submissions/getInvoice/` + form_id + `?type=` + type + `&token=` + this.$auth.token()
        },
        downloadCSV() {
            let url = '/api/v1/admin/csv?token=' + this.$auth.token();
            if (this.formType) {
                url = url + '&formType=' + this.formType;
            }
            window.open(url, '_blank').focus();
        },
        sendInvoice(proforma) {
            this.fullScreenLoading = true;
            adminApi.issueInvoice(this.rowToShow.id, proforma).then((r) => {
                if (r && r.data && r.data.success) {
                    this.$notify({
                        title: 'Success',
                        message: 'The invoice was sent successfully!',
                        type: 'success',
                        duration: 10000
                    });
                    this.loadData();
                    if(proforma) {
                        this.rowToShow.proforma = true;
                    }else{
                        this.rowToShow.invoice = true;
                    }
                } else {
                    this.$notify({
                        title: 'Error',
                        message: 'Something went wrong while issuing/sending the invoice. Please try again.',
                        type: 'error',
                        duration: 10000
                    });
                }
            }).catch((err) => {
                this.$notify({
                    title: 'Error',
                    message: 'Something went wrong! Please contact the webmaster mentioning the form id.',
                    type: 'error',
                    duration: 10000
                });
            }).finally(() => {
                this.fullScreenLoading = false;
            })
        },
        getFile(fileName) {
            window.open('/api/v1/admin/file?filename=' + fileName + '&token=' + this.$auth.token(), '_blank').focus();
        },
        handleShowDetails(row) {
            this.rowToShow = row;
            this.dialogVisible = true;
        },
        handleSortChange({column, prop, order}) {
            if (!order) {
                this.sort = {prop: 'id', order: 'desc'};
            } else {
                this.sort = {prop: prop, order: order};
            }
            this.loadData();
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.loadData();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.loadData();
        },
        loadData() {
            this.loading = true;
            adminApi.getList({
                search: this.search,
                formType: this.formType,
                page: this.currentPage,
                perPage: this.pageSize,
                orderBy: this.sort.prop,
                orderWay: (this.sort.order == 'ascending' ? 'asc' : 'desc')
            }).then((r) => {
                this.tableData = r.data.data;
                this.total = r.data.total;
            }).catch((err) => {

            }).finally(() => {
                this.loading = false;
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.el-select--mini .el-input__inner {
    padding-right: 0 !important;
}
</style>
